import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from './components/LandingPage';
import HorseboxInfo from './components/HorseboxInfo';
import FullGallery from './components/FullGallery';
import PrivacyPolicy from './components/PrivacyPolicy';
import CookiePolicy from './components/CookiePolicy';
import { Toaster } from './components/ui/sonner';
import {
  AuthProvider,
  AuthCallback,
  ProtectedRoute,
  AdminLogin,
  AdminDashboard,
  CustomerList,
  CustomerForm,
  BookingList,
  BookingForm,
  AttachmentList,
  TemplateList,
  TemplateForm,
  SendEmail,
  HandoverForm,
  BlockedDatesList
} from './components/admin';

// Router component that handles session_id detection
function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id - must be synchronous during render
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Check both hash fragment and query params for mobile compatibility
  const hashHasSession = location.hash?.includes('session_id=');
  const searchHasSession = location.search?.includes('session_id=');
  
  if (hashHasSession || searchHasSession) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/horsebox-info" element={<HorseboxInfo />} />
      <Route path="/gallery" element={<FullGallery />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/cookie-policy" element={<CookiePolicy />} />

      {/* Admin Routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={
        <ProtectedRoute>
          <AdminDashboard />
        </ProtectedRoute>
      } />
      <Route path="/admin/customers" element={
        <ProtectedRoute>
          <CustomerList />
        </ProtectedRoute>
      } />
      <Route path="/admin/customers/new" element={
        <ProtectedRoute>
          <CustomerForm />
        </ProtectedRoute>
      } />
      <Route path="/admin/customers/:customerId" element={
        <ProtectedRoute>
          <CustomerForm />
        </ProtectedRoute>
      } />
      <Route path="/admin/bookings" element={
        <ProtectedRoute>
          <BookingList />
        </ProtectedRoute>
      } />
      <Route path="/admin/bookings/new" element={
        <ProtectedRoute>
          <BookingForm />
        </ProtectedRoute>
      } />
      <Route path="/admin/bookings/:bookingId" element={
        <ProtectedRoute>
          <BookingForm />
        </ProtectedRoute>
      } />
      <Route path="/admin/bookings/:bookingId/send-email" element={
        <ProtectedRoute>
          <SendEmail />
        </ProtectedRoute>
      } />
      <Route path="/admin/bookings/:bookingId/handover" element={
        <ProtectedRoute>
          <HandoverForm />
        </ProtectedRoute>
      } />
      <Route path="/admin/attachments" element={
        <ProtectedRoute>
          <AttachmentList />
        </ProtectedRoute>
      } />
      <Route path="/admin/email-templates" element={
        <ProtectedRoute>
          <TemplateList />
        </ProtectedRoute>
      } />
      <Route path="/admin/email-templates/new" element={
        <ProtectedRoute>
          <TemplateForm />
        </ProtectedRoute>
      } />
      <Route path="/admin/email-templates/:templateId" element={
        <ProtectedRoute>
          <TemplateForm />
        </ProtectedRoute>
      } />
      <Route path="/admin/send-email" element={
        <ProtectedRoute>
          <SendEmail />
        </ProtectedRoute>
      } />
      <Route path="/admin/blocked-dates" element={
        <ProtectedRoute>
          <BlockedDatesList />
        </ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;